import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { getFilterDispName } from './DataTable.tsx';
import { Dialog, DialogActions, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";


import { widthStyleDataEntry } from './DataTable.tsx';

export function FilterChips({ filteringColumns, deleteFilterForColumn, columns }) {

    return (
        <div>
            <Stack direction="row" spacing={1} style={{ 'marginBottom': '10px' }}>
                {Object.entries(filteringColumns).map(([column, value]) => {
                    var colDisplayName = getFilterDispName(columns, column);
                    const valueString = value ? value.toString() : "";

                    if (valueString && valueString.length > 0) {
                        return <Chip key={column} label={colDisplayName + " contains " + valueString} variant="outlined" onDelete={() => deleteFilterForColumn(column)} />;
                    } else {
                        return null;
                    }
                })}
            </Stack>
        </div>
    );

} export function FilterDialog({ columns, filterColumn, currentFilterValue, updatedFilterValue, showFilterDialog, setShowFilterDialog, userSetFilter }) {

    const handleCloseFilter = () => {
        setShowFilterDialog(false);
        userSetFilter();

    };

    const handleClearFilter = () => {
        updatedFilterValue(null);
        setShowFilterDialog(false);
    };

    return (
        <Dialog onClose={() => setShowFilterDialog(false)} open={showFilterDialog}
            fullWidth={true}
            maxWidth="md"
        >

            <FilterEditor columns={columns} columnName={filterColumn} filterValue={currentFilterValue} setFilterValue={updatedFilterValue} />

            {/* update  */}
            <DialogActions>
                <Button onClick={handleCloseFilter} autoFocus>Set filter</Button>
                <Button onClick={handleClearFilter}>Clear filter</Button>
            </DialogActions>
        </Dialog>
    );
}

export function FilterEditor({ columns, columnName, filterValue, setFilterValue }) {
    return (
        <span style={{ "margin": "40px" }}>

            <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 4, sm: 8 }}>
                <>

                    <Grid item xs={2} sm={4} md={4} key={columnName}>

                        {getFilterDispName(columns, columnName)}

                    </Grid>

                    <Grid item xs={2} sm={4} md={4} key={columnName + 'value'}>

                        <TextField
                            key={columnName + 'textfield'}
                            multiline={false}
                            name={columnName}
                            value={filterValue}
                            style={widthStyleDataEntry}
                            onChange={(event) => setFilterValue(event.target.value)} />

                    </Grid>
                </>


            </Grid>
        </span>
    );
}

